<template>
    <a-modal :title="$t('platformCollection.investment_order_details')" :width="1000" :visible="visible" :footer="null" @cancel="handleCancel">
        <div class="detail-container">
            <!-- Basic info display area -->
            <div class="info-section">
                <a-row :gutter="[16, 24]">
                    <a-col :span="8">
                        <span class="label">{{ $t('investorList.tzddbh') }}:</span>
                        <span class="value">{{ model.id }}</span>
                    </a-col>
                    <a-col :span="8">
                        <span class="label">{{ $t('investorList.tzrmc') }}:</span>
                        <span class="value">{{ model.name }}</span>
                    </a-col>
                    <a-col :span="8">
                        <span class="label">{{ $t('investorList.tzrzh') }}:</span>
                        <span class="value">{{ model.mobile }}</span>
                    </a-col>

                    <a-col :span="8">
                        <span class="label">{{ $t('investorList.tzrlx') }}:</span>
                        <span class="value">{{ typeFilter(model.type) }}</span>
                    </a-col>
                    <a-col :span="8">
                        <span class="label">{{ $t('investorList.tzzcbid') }}:</span>
                        <span class="value">{{ model.investId }}</span>
                    </a-col>
                    <a-col :span="8">
                        <span class="label">{{ $t('investorList.tzje') }}:</span>
                        <span class="value">{{ model.investAmount | FenToDong }}</span>
                    </a-col>

                    <a-col :span="8">
                        <span class="label">{{ $t('investorList.tzhbl') }}:</span>
                        <span class="value">{{ model.investYieldRate }}%</span>
                    </a-col>
                    <a-col :span="8">
                        <span class="label">{{ $t('investorList.tzzq') }}:</span>
                        <span class="value">{{ model.investDuration }}</span>
                    </a-col>
                    <a-col :span="8">
                        <span class="label">{{ $t('investorList.yqsy') }}:</span>
                        <span class="value">{{ calcExpectIncome(model) | FenToDong }}</span>
                    </a-col>

                    <a-col :span="8">
                        <span class="label">{{ $t('investorList.ptffw') }}:</span>
                        <span class="value">{{ model.platformServiceAmount | NumberFormat }}</span>
                    </a-col>
                    <a-col :span="8">
                        <span class="label">{{ $t('investorList.tzsj') }}:</span>
                        <span class="value">{{ model.createTime }}</span>
                    </a-col>
                </a-row>
            </div>

            <!-- Investment status -->
            <div class="status-section">
                <div class="status-title">{{ $t('investorList.tzrzt') }}:</div>
                <div class="steps-wrapper">
                    <a-steps direction="vertical" size="small" :current="currentStep">
                        <a-step v-for="(item, index) in statusSteps" :key="index">
                            <template slot="title">
                                <span class="step-name" :class="{ 'active': index === currentStep }">{{ item.name
                                }} </span>
                            </template>
                            <template slot="description">
                                <span class="step-time">{{ item.time }}</span>
                            </template>
                        </a-step>
                    </a-steps>
                </div>
            </div>
        </div>
    </a-modal>
</template>

<script>
import { getInvestStatusList } from '@/webpublicapi/vietnamBackstage'

export default {
    name: 'InvestmentOrderDetailModal',
    data() {
        return {
            visible: false,
            model: {},
            statusSteps: [],
            currentStep: 0
        }
    },
    methods: {
        async show(record) {
            this.model = Object.assign({}, record)
            this.visible = true
            await this.initStatusSteps(record)
        },
        handleCancel() {
            this.visible = false
        },
        typeFilter(type) {
            const typeMap = {
                1: this.$t('investorList.gr'),
                10: this.$t('investorList.qy')
            }
            return typeMap[type] || this.$t('platformCollection.unknown')
        },
        calcExpectIncome(record) {
            const amount = Number(record && record.investAmount)
            const rate = Number(record && record.investYieldRate)
            if (!Number.isFinite(amount) || !Number.isFinite(rate)) return 0
            return amount * (1 + rate / 100)
        },
        formatCreateDate(dateStr) {
            if (!dateStr) return '--'
            const date = new Date(dateStr)
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            const hours = String(date.getHours()).padStart(2, '0')
            const minutes = String(date.getMinutes()).padStart(2, '0')
            const seconds = String(date.getSeconds()).padStart(2, '0')
            return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`
        },
        async initStatusSteps(record) {
            try {
                const res = await getInvestStatusList({ id: record.id })
                // Based on latest API response structure, use respData Field
                if (res.success && res.respData) {
                    const statusMap = {
                        0: this.$t('investorList.fqrg'),
                        1: this.$t('investorList.rgcg'),
                        2: this.$t('investorList.rgsb'),
                        3: this.$t('investorList.fqtk'),
                        4: this.$t('investorList.tkcg'),
                        5: this.$t('investorList.mb'),
                        6: this.$t('investorList.zjchz'),
                        7: this.$t('investorList.yjs')
                    }
                    // Iterate respData Array, build step bar data
                    this.statusSteps = res.respData.map(item => ({
                        name: statusMap[item.status] || this.$t('platformCollection.unknown_status'),
                        time: this.formatCreateDate(item.createDate)
                    }))
                    // Set current step to the last record
                    this.currentStep = this.statusSteps.length - 1
                } else {
                    this.$message.warning(res.respMsg || this.$t('platformCollection.get_status_list_failed'))
                    this.statusSteps = []
                }
            } catch (error) {
                console.error(this.$t('platformCollection.get_investment_status_failed'), error)
                this.$message.error(this.$t('platformCollection.get_investment_status_failed'))
                this.statusSteps = []
            }
        }
    }
}
</script>

<style lang="less" scoped>
.detail-container {
    padding: 10px 20px;

    .info-section {
        margin-bottom: 40px;

        .label {
            color: #333;
            font-weight: 500;
        }

        .value {
            color: #666;
        }
    }

    .status-section {
        display: flex;

        .status-title {
            width: 80px;
            font-weight: 500;
            color: #333;
        }

        .timeline-wrapper {
            flex: 1;
            padding-top: 5px;

            .timeline-content {
                .step-name {
                    font-size: 14px;
                    color: #999;
                    margin-bottom: 4px;

                    &.active {
                        color: #333;
                        font-weight: bold;
                    }
                }

                .step-time {
                    font-size: 12px;
                    color: #999;
                }
            }
        }
    }
}

/deep/ .ant-timeline-item-tail {
    border-left: 2px solid #e8e8e8;
}

/deep/ .ant-timeline-item-head-blue {
    background-color: #1890ff;
    border-color: #1890ff;
}
</style>
